
import Vue from 'vue';
import { mapState, mapActions, mapGetters } from "vuex";
import {
	TRAINING_TYPE_CARDS

} from "@/views/Runnits/constants";
import {
	RUNNIT_NODE_DEF_TAG_TYPE,
	RunnitNodeDef
} from "@run-diffusion/shared";

export default Vue.extend({
	name: 'TrainerUploadEmptyState',
	props: {
		imageSrc1: { type: String, default: null },
		imageSrc2: { type: String, default: null },
		containerClasses: { type: String, default: 'my-12 py-12' },
	},
	computed: {
		...mapState([
			'modelsState',
			'runnitState',
			'publicRunnitNodeDefTagsMap',
			'runnitNodesMap',
		]),
		...mapGetters([
			'canDownloadModels',
		]),
		categoryTitle () {
			if (this.runnitNodesMap && this.runnitState.selectedNodeId) {
				const nodeDef: RunnitNodeDef = this.runnitNodesMap[this.runnitState.selectedNodeId]?.nodeDef;

				if (nodeDef) {
					const trainingTypeTag = Object.keys(nodeDef.tags).find((tagId: string) => this.publicRunnitNodeDefTagsMap[tagId]?.type === RUNNIT_NODE_DEF_TAG_TYPE.TRAINING_TYPE);
					return TRAINING_TYPE_CARDS[trainingTypeTag]?.title || 'Model';
				}
			}

			return 'Model';
		},
		imagePaths () {
			if (this.runnitNodesMap && this.runnitState.selectedNodeId) {
				const nodeDef: RunnitNodeDef = this.runnitNodesMap[this.runnitState.selectedNodeId]?.nodeDef;

				if (nodeDef) {
					const trainingTypeTag = Object.keys(nodeDef.tags).find((tagId: string) => this.publicRunnitNodeDefTagsMap[tagId]?.type === RUNNIT_NODE_DEF_TAG_TYPE.TRAINING_TYPE);
					return TRAINING_TYPE_CARDS[trainingTypeTag]?.imagePaths || [];
				}
			}

			return [];
		},
	},
	methods: {
		...mapActions([
			'setUpsellDialog',
		]),
	},
});
